import React, {
  useState
} from 'react'
import Answers from './answers'
import { motion } from 'motion/react'
import AnimInCorrect from './animincorrect'
import AnimCorrect from './animcorrect'

import quizquestionimg from 'assets/images/uam/quiz-question-a.png'

export default props => {

  const [ showAnswers, setShowAnswers ] = useState(false)
  const [ showQuestion, setShowQuestion ] = useState(false)

  const show = () => {

    setTimeout(() => {

      setShowAnswers(true)

    }, 3000)
  }
   
  return <div className="quizquestion">
    <div className="image">
      <motion.img 
        src={ quizquestionimg } 
        initial={{ 
          transform: 'translateX(-50%) translateY(100%)'
        }}
        animate={{ 
          transform: `translateX(-50%) translateY(${ showQuestion ? 0 : 100 }%)`
        }}
        transition={{
          duration: 0.8
        }}        
      />
    </div>
    <motion.div 
      className="question" 
      initial={{ 
        opacity: 0
      }}
      animate={{ 
        opacity: 1
      }}
      transition={{
        duration: 0.5,
        delay: 0.5
      }}  
      onAnimationComplete={() => setShowQuestion(true) }    
    >
      <motion.div
        className="questiontext" 
        initial={{ 
          opacity: 0
        }}
        animate={{ 
          opacity: showQuestion ? 1 : 0
        }}
        transition={{
          duration: 0.8
        }}   
        onAnimationComplete={ show }    
      >
        {
          props.state.question
        }  
      </motion.div>
      {
        showAnswers &&
        <div 
          className="answerswrapper"
        >
          <Answers 
            state={ props.state }     
            dispatch={ props.dispatch }       
          />
        </div>
      }
      {
        props.state.correct &&
        <AnimCorrect />
      }
      {
        props.state.incorrect &&
        <AnimInCorrect />
      }
    </motion.div>
  </div>
}
